








































































import { Vue, Component, Watch } from 'vue-property-decorator';
import FinishingAllianzProcessViewModel
  from '@/vue-app/view-models/components/contract-savings/allianz/finishing-allianz-process-view-model';

@Component({
  name: 'FinishingAllianzProcess',
  components: {
    SuccessfulAllianzProcess: () => import('@/vue-app/components/contract-savings/allianz/successful-allianz-process.vue'),
    AccountStatusErrorAllianzProcess: () => import('@/vue-app/components/contract-savings/allianz/account-status-error-allianz-process.vue'),
    ErrorAllianzProcess: () => import('@/vue-app/components/contract-savings/allianz/error-allianz-process.vue'),
    ContractTimeout: () => import('@/vue-app/components/contracts/timeout/ContractTimeout.vue'),
  },
})
export default class FinishingAllianzProcess extends Vue {
  view_model = Vue.observable(
    new FinishingAllianzProcessViewModel(this),
  );

  @Watch('view_model.status.percent')
  onPercentChange(percent: number) {
    if (percent === 100) {
      this.$emit('loadingInfo', false);
    }
  }

  @Watch('view_model.status.has_problem')
  onStatusHasProblemChange() {
    this.$emit('loadingInfo', false);
    this.view_model.openIfRequiredAccountStatusErrorModal();
    this.view_model.openIfRequiredErrorModal();
  }

  created() {
    this.view_model.openIfRequiredAccountStatusErrorModal();
    this.view_model.openIfRequiredErrorModal();
    this.view_model.initialize();
  }
}
